import { useMemo } from "react"

import { groupBy } from "shared/lib/arrayUtils"

import {
  useProjectAttachmentCategoriesQuery,
  useProjectAttachmentsByShareLinkQuery
} from "entities/attachments/graphql/project-attachments.queries.generated"

import { ProjectAttachmentsModel } from "../ProjectAttachments"

interface UseSharedProjectAttachmentsModelArgs {
  projectID: string
}

export function useSharedProjectAttachmentsModel({
  projectID
}: UseSharedProjectAttachmentsModelArgs): ProjectAttachmentsModel {
  const {
    data,
    loading: isLoading,
    error: attachmentsError
  } = useProjectAttachmentsByShareLinkQuery({
    variables: { id: projectID }
  })
  const {
    data: categoriesData,
    loading: isLoadingCategories,
    error: categoriesError
  } = useProjectAttachmentCategoriesQuery()

  const filesByCategory = useMemo(() => {
    return groupBy(data?.attachments || [], file => file.category || "unknown")
  }, [data?.attachments])

  return {
    files: data?.attachments,
    categories: categoriesData?.projectAttachmentCategories.categories,
    acceptsByCategory: {},
    filesByCategory,
    isLoading: isLoading || isLoadingCategories,
    isError: !!attachmentsError || !!categoriesError,
    isReadonly: true
  }
}
